<template>
	<div style="display: flex;">



		<div class="dis" style="flex-wrap: wrap;justify-content: flex-start;">
			<!-- 已上传的图片列表start -->
			<div v-for="(item,index) in meImgList" @mouseenter="enter(index)" @mouseleave="leave" :key="index" style="position: relative;margin-right: 10px;overflow: hidden;border-radius: 5px;">
				<img :src="item.url" style="width: 60px;height: 60px;border-radius: 5px;" />

				<div v-if="mouseenterIndex==index" style="cursor: pointer; font-size: 17px; position: absolute;right: 0px;top:0;background: rgba(0,0,0,0.5);width: 60px;height: 60px;border-radius: 5px;display: flex;justify-content: center;align-items: center;color: #fff;">
					<i @click="preImg(item.url)" class="el-icon-zoom-in" style="margin-right: 10px;"></i>
					<i @click="del(index)" class="el-icon-delete"></i>
				</div>


			</div>
			<!-- 已上传的图片列表end -->

			<el-upload ref="upload" v-if="isShowUploadBtn" class="my-el-upload" multiple :accept="accept" :limit="limit" :action="uploadUrl" :show-file-list="false" :data="uploadAxajParam" :before-upload="imageBefore" :on-success="editImageSuccess" :on-exceed="limitExceed" :on-error="imageError" :file-list="meImgList">

				<img v-if="meImgList.length < limit" src="../../assets/upload.png" style="width: 60px;height: 60px;" />

			</el-upload>
		</div>

		<!-- 全屏透明的loading加载start -->
		<div v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" :modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImgPop">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->

	</div>
</template>

<script>
	export default {
		props: {
			//用于for循环时的index
			eleIndex: {
				type: Number,
				default: -1
			},
			//是否显示上传按钮
			isShowUploadBtn: {
				type: Boolean,
				default: true
			},
			//可上传的文件类型 image/png,image/jpeg
			accept: {
				type: String,
				default: 'image/png'
			},
			//可上传的文件后缀名 '.png'
			fileAfterName: {
				type: String,
				default: null
			},

			//上传的文件列表
			imgList: {
				type: Array,
				default: function() {
					return []
				}
			},
			//可上传文件的总个数
			limit: {
				type: Number,
				default: 6
			},
			//可上传文件图片的宽度
			imgWidth: {
				type: Number,
				default: 0
			},
			//可上传文件图片的高度
			imgHeight: {
				type: Number,
				default: 0
			},
			//上传文件到服务器文件夹名路径
			dir: {
				type: String,
				default: 'img/'
			},
			// 最大允许上传的文件大小，单位MB
			fileSize: {
				type: Number,
				default: 100,
			},



		},
		name: 'uploadImg',
		components: {},
		data() {
			return {
				meImgList:[],//解决批量上传出现的错误,原因是子组件不能修改父组件传来的数据，解决方法为把父组件传来的数据赋值给子组件本身自由的数据
				UpLoadFilesLength:0,//已上传多少个,
				mouseenterIndex: -1, //鼠标移入到的图片索引号
				uploadUrl: '', //上传到的文件地址
				uploadAxajParam: {}, //文件上传时携带的请求参数
				loading: false,
				isShowPreImgPop: false, //是否弹出浏览弹窗
				preImgUrl: '', //浏览的图片url
			}
		},
		watch:{
			//监听图片列表的变化
			imgList(newVal, oldVal){
				console.log('触发watch')
				this.resetImgList();
			}
			
		},
		mounted() {
			
			this.resetImgList();
			
			
		},
		methods: {
			
			//回显和图片列表改变
			resetImgList(){
				
				
				setTimeout(()=>{
					this.meImgList = [...this.imgList];//创建新数组
					
					if(this.meImgList.length==1&& !(this.meImgList[0].url)){
						this.meImgList = [];
						console.log("数组第一个元素的url为空字符串");
						return;
					}
					
					//回显
					console.log('未循环回显this.imgList=',this.imgList)
					console.log('未循环回显this.meImgList=',this.meImgList)
					if(this.meImgList.length>0){
				
						for (let index in this.meImgList) {
							this.meImgList[index].name = index;
							this.meImgList[index].percentage = 100;
							this.meImgList[index].response = {
								message:"success",
								code:0,
								data:{url:this.meImgList[index].url}
							};
							this.meImgList[index].size = 100;
							this.meImgList[index].status = "success";
							this.meImgList[index].uid = index;
							
						}
						this.$refs.upload.uploadFiles = this.meImgList;
						this.UpLoadFilesLength = this.meImgList.length;
						console.log('循环后回显this.meImgList=',this.meImgList)
						console.log('循环后回显this.$refs.upload.uploadFiles=',this.$refs.upload.uploadFiles)
					}
				},1000)
			},
			
			
			//清空图片列表
			clearImgList() {
				this.meImgList = [];
			},
			//鼠标移入图片
			enter(index) {
				console.log('移入', index)
				this.mouseenterIndex = index;
			},
			//鼠标移除图片
			leave() {
				console.log('移出')
				this.mouseenterIndex = -1;
			},
			//浏览图片
			preImg(url) {
				this.preImgUrl = url;
				this.isShowPreImgPop = true;
			},
			//删除文件
			del(index) {
				this.UpLoadFilesLength = this.UpLoadFilesLength-1;
				this.meImgList.splice(index, 1);
				this.$refs.upload.uploadFiles.splice(index, 1);
				console.log('删除后的列表meImgList', this.meImgList)
				console.log('删除后的列表this.$refs.upload.uploadFiles', this.$refs.upload.uploadFiles)
			},
			
			//删除所有文件
			clearAll(){
				this.UpLoadFilesLength = 0;
				this.meImgList=[];
				this.$refs.upload.uploadFiles=[];
			},

			//获取文件列表
			getImgList() {
				return this.meImgList;
			},

			//每个文件上传之前
			async imageBefore(file) {
				//先调用store中的方法检查上传文件的令牌是否过期
				let uploadParamObj = await this.$store.dispatch('getOSSUploadSign');
				console.log('uploadParamObj=>', uploadParamObj)

				// 判断图片宽高
				if (!(await this.dpiError(file))) {
					return false
				}
				console.log('1=>')
				// 格式
				const prefix = file.name.substring(0, file.name.lastIndexOf('.'))
				const suffix = file.name.substring(file.name.lastIndexOf('.'))
				//设置了文件后缀名校验
				if (this.fileAfterName) {
					if (suffix !== this.fileAfterName) {
						console.log('suffix: ' + suffix, 'type: ' + file.type)
						this.$message.error('文件格式仅限 ' + this.fileAfterName)
						this.loading = false;
						this.$emit('isShowLoading', false)
						return false
					}
				}


				let isSize = file.size / 1024 / 1024; // 文件大小
				if (this.fileSize && isSize > this.fileSize) {
					this.$message.error(`上传图片大小不能超过${this.fileSize}MB`);
					this.loading = false;
					this.$emit('isShowLoading', false)
					return false;
				}


				console.log('准备开始上传=>')
				this.loading = true;
				this.$emit('isShowLoading', true)
				const name = new Date().getTime() + Math.floor(Math.random() * 10000) //生成上传的文件名
				this.uploadUrl = uploadParamObj.ossHost; //上传到的服务器地址
				this.uploadAxajParam = { //上传到文件服务器时携带的参数
					key: this.dir + name + suffix, //上传到的路径地址
					signature: uploadParamObj.signature,
					policy: uploadParamObj.policy,
					callback: uploadParamObj.callback,
					OSSAccessKeyId: uploadParamObj.OSSAccessKeyId,
					success_action_status: uploadParamObj.success_action_status
				}
			},
			//上传失败
			imageError() {
				this.$message.error('上传失败');
				this.loading = false;
				this.$emit('isShowLoading', false)
			},
			//上传超出个数
			limitExceed() {
				this.$message.error('只能上传' + this.limit + '个');
				this.loading = false;
				this.$emit('isShowLoading', false)
			},
			//上传成功后
			editImageSuccess(res, file, fileList) {
				
				//一定要在setTimeout里写，否则会出现 Uncaught TypeError: Cannot set properties of null (setting 'status')错误
				//解决批量上传出现的错误,原因是vue规定子组件不能修改父组件传来的数据，解决方法为把父组件传来的数据赋值给子组件本身自由的数据
				let length = this.$refs.upload.uploadFiles.length;//要上传文件的总数量
				this.UpLoadFilesLength = this.UpLoadFilesLength +1;  // 全局变量，用来计算upLoadSuccess方法调用次数
				console.log('length',length)
				console.log('UpLoadFilesLength',this.UpLoadFilesLength)
				
				
				if (this.UpLoadFilesLength == length) {//上传成功到最后一个文件了
					 // 如果方法调用的次数和文件列表的长度相同，说明所有文件都上传完毕，将该全局变量置0
					this.resErrorStr(res) // 该函数处理每个文件上传错误情况下response拼接
					console.log(1)
					console.log('UpLoadFilesLength',this.UpLoadFilesLength)
				}
				
				console.log(2)
				
			},
			
			//判断上传文件出错
			resErrorStr(res) {
			    if (this.$refs.upload.uploadFiles) { // 如果存在这个值
			        let filesList = this.$refs.upload.uploadFiles.slice()//复制出一个新的数组
			        let UpLoadAllErrorStr = '' // 错误信息拼接变量
			        for (let i = 0; i < filesList.length; i++) {
			            if (filesList[i].response) {
			                if (filesList[i].response.message != "success") { // 如果该文件上传后返回的状态值不是200，则说明该文件上传错误
			                    UpLoadAllErrorStr += `${filesList[i].response.message}<br/>`
			                }
			            }
			        }
					//上传成功
			        if (!UpLoadAllErrorStr) {
			           
						setTimeout(() => {
							this.$message({ type: 'success', message: '上传文件成功！' });
							
							//一定要在setTimeout里写，否则会出现 Uncaught TypeError: Cannot set properties of null (setting 'status')错误
							//解决批量上传出现的错误,原因是vue规定子组件不能修改父组件传来的数据，解决方法为把父组件传来的数据赋值给子组件本身自由的数据
							// this.meImgList.push({
							// 	url: res.data.url
							// });
							
							let filesListSuccess = this.$refs.upload.uploadFiles.slice()//复制出一个新的数组
							let arr = [];
							
							for (let item of filesListSuccess) {
								console.log('item',item)
								if(item.response){
									item.url = item.response.data.url;
									arr.push(item)
								}
								
							}
							
							
							
							this.meImgList = arr;
							console.log('上传成功后的meImgList', this.meImgList)
							this.loading = false;
							this.$emit('isShowLoading', false);
							this.$emit('uploadSuccess', this.meImgList,this.eleIndex); //触发标签上的事件uploadSuccess把上传成功的列表传给父标签
						}, 3000);
						
			        } else {
						//上传失败的文件列表提示
			            this.$message({
			                type: 'error',
			                dangerouslyUseHTMLString: true,
			                message: UpLoadAllErrorStr
			            });
			        }
			        //this.$refs.uploadAll.uploadFiles = [] // 调用完成之后将值置空，防止再次上传将上次结果也记录下来
			    }
			},

			//判断上传的图片宽高是否超出
			dpiError(file) {
				console.log('2=>', file)
				return new Promise((resolve, reject) => {
					const img = new Image()
					const url = window.URL || window.webkitURL

					img.src = url.createObjectURL(file)
					img.onload = () => {


						//设置限制图片文件的宽高
						if (this.imgWidth && this.imgHeight) {
							if (img.width != this.imgWidth && img.height != this.imgHeight) {
								this.$message.error('图片宽高仅限 ' + this.imgWidth + ' * ' + this.imgHeight)
								this.loading = false;
								this.$emit('isShowLoading', false)
								return reject(false)
							}
						}

						return resolve(true)


					}


				})
			},
		}
	}
</script>

<style scoped>



</style>



<!-- 使用方式start -->

<!-- 

<!- 全屏透明的loading加载start ->
<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
	<i class="el-icon-loading" style="font-size: 25px;"></i>
</div>
<!- 全屏透明的loading加载end ->

<!- 上传图片组件start ->
<upload-img @isShowLoading="isShowLoadingFn" :imgWidth="750" :imgHeight="735" :limit='6' accept="image/png或image/*" fileAfterName=".png" ref="goodsImgUpload" :imgList="images"></upload-img>
<!- 上传图片组件end ->


import uploadImg from '../upload/uploadImg.vue'

export default {

		components: {
			uploadImg
		},
		data() {
		
			return {
				loading:false,//是否显示加载中图标
				images: [], //图片
			}
		},
		
		methods:{
			//回显数据
			async getGoodsDetail() {
			
				this.loading = true
				let res = await ajax('/goods/detail', 'GET', {
					goods_id: this.goods_id
				}); //获取sku名称列表
				let goods = res.data.data.goods;
			
				this.loading = false;
				this.images=[{
						url: goods.image
					}];//<upload-img>组件要的回显图片的格式
			},
			
			//上传图片时是否显示loading
			isShowLoadingFn(bool) {
				this.loading = bool
			},
			
			//提交
			submit(){
				//在表单校验前要先获取<upload-img>组件上的图片列表数据，否则会出现已上传了图片表单还提示校验不通过的问题
				this.images = this.$refs.goodsImgUpload.getImgList(); //获取<upload-img>组件上的已上传的图片列表,返回的格式为 [{....,url:'图片地址'}] 
			},
			
		}
		
} -->

<!-- 使用方式end -->
